import { useRef, useState } from "react";

import { create } from "zustand";

const useSuperSearchStore = create((set) => ({
  isActive: false,
  setIsActive: (newBool) => set({ isActive: newBool }),
  value: "",
  setValue: (newValue) => set({ value: newValue }),
  toggleRef: { current: null },
}));

const useIsActive = () => {
  const isActive = useSuperSearchStore((s) => s.isActive);
  const setIsActive = useSuperSearchStore((s) => s.setIsActive);

  return [isActive, setIsActive];
};

const useValue = () => {
  const value = useSuperSearchStore((s) => s.value);
  const setValue = useSuperSearchStore((s) => s.setValue);

  return [value, setValue];
};

const useToggleRef = () => {
  return useSuperSearchStore((s) => s.toggleRef);
};

const useSuperSearchState = (isNavToolbar) => {
  const [storeIsActive, storeSetIsActive] = useIsActive();
  const storeToggleRef = useToggleRef();
  const [storeValue, storeSetValue] = useValue();

  const [localIsActive, localSetIsActive] = useState(false);
  const localToggleRef = useRef(null);
  const [localValue, localSetValue] = useState("");

  if (isNavToolbar) {
    return {
      isActive: storeIsActive,
      setIsActive: storeSetIsActive,
      toggleRef: storeToggleRef,
      value: storeValue,
      setValue: storeSetValue,
    };
  }

  return {
    isActive: localIsActive,
    setIsActive: localSetIsActive,
    toggleRef: localToggleRef,
    value: localValue,
    setValue: localSetValue,
  };
};

export { useIsActive, useValue, useToggleRef, useSuperSearchState };
export default useSuperSearchStore;
